module.exports = __webpack_public_path__ + "static/media/garage-open.2cf91873.svg";